import { create } from 'zustand';
import { billingService, FALLBACK_PRICING, type Pricing, type TeamBilling } from './billingService';

interface BillingStoreState {
  byTeam: Record<string, TeamBilling | undefined>;
  pricing: Pricing;
  /** 读取（或刷新）某个团队的计费状态；失败时保持旧值，不打断使用 */
  load: (teamId: string) => Promise<void>;
  loadPricing: () => Promise<void>;
}

export const useBillingStore = create<BillingStoreState>((set, get) => ({
  byTeam: {},
  pricing: FALLBACK_PRICING,

  load: async (teamId) => {
    try {
      const data = await billingService.getTeamBilling(teamId);
      set({ byTeam: { ...get().byTeam, [teamId]: data }, pricing: data.pricing });
    } catch (e) {
      console.error('读取团队计费状态失败:', e);
    }
  },

  loadPricing: async () => {
    try {
      set({ pricing: await billingService.getPricing() });
    } catch {
      /* 用兜底价格 */
    }
  },
}));
